import { Skeleton } from "@/components/skeleton";

import { RecentInvoicesRowsSkeleton } from "../../../components/overview/components/OverviewSkeleton";
import {
  ADMIN_OVERVIEW_GRID,
  ADMIN_RECENT_INVOICES_CELL,
  ADMIN_SIDE_COLUMN,
} from "../utils/admin-overview-grid";

export function AdminOverviewSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading account overview">
      <div className={ADMIN_OVERVIEW_GRID}>
        {Array.from({ length: 4 }, (_, index) => (
          <CardSkeleton key={index} />
        ))}

        <div className={ADMIN_RECENT_INVOICES_CELL}>
          <Skeleton className="h-4.5 w-36" />
          <RecentInvoicesRowsSkeleton count={4} />
        </div>

        <div className={ADMIN_SIDE_COLUMN}>
          <CardSkeleton />
          <CardSkeleton />
        </div>
      </div>
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="flex flex-col gap-md rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl">
      <Skeleton className="h-3.5 w-24" />
      <Skeleton className="h-8 w-40" />
      <Skeleton className="h-3.5 w-32" />
    </div>
  );
}
